export default __webpack_public_path__ + "static/media/desktop_i_calendar.18ca6940.svg";